import styled from '@emotion/styled';

import { COLOR_BRAND } from './utils/variables';

export const FieldCheckbox = styled.input`
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
  accent-color: ${COLOR_BRAND};
`;
